import { Star } from "lucide-react";
import { tint } from "@/lib/mall";

export const RatingStars = ({ n, size = 13, color = "#f5b544" }) => (
    <span className="inline-flex items-center gap-px" aria-label={`${n} out of 5`}>
        {[1, 2, 3, 4, 5].map((i) => (
            <Star key={i} size={size} strokeWidth={2}
                style={i <= Math.round(n) ? { fill: color, color } : { color: "rgba(140,140,150,0.55)" }} />
        ))}
    </span>
);

const day = (iso) => { try { return new Date(iso).toLocaleDateString(); } catch { return ""; } };

/** The wall of what customers said — mall chrome, not back-office chrome. */
export default function StoreReviews({ data, theme, name }) {
    const stats = data?.stats;
    if (!stats?.count) return null;
    const rows = data.reviews.slice(0, 6);

    return (
        <div id="reviews" className="mt-14 scroll-mt-24" data-testid="store-reviews">
            <div className="flex flex-wrap items-end justify-between gap-4">
                <h2 className="font-display text-3xl font-black tracking-tight">What customers say</h2>
                <div className="flex items-center gap-3">
                    <span className="font-display text-3xl font-black" data-testid="store-rating-average">{stats.average}</span>
                    <span>
                        <RatingStars n={stats.average} size={15} color={theme?.primary || "#f5b544"} />
                        <p className="mt-0.5 font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-400"
                            data-testid="store-rating-count">{stats.count} review{stats.count === 1 ? "" : "s"}</p>
                    </span>
                </div>
            </div>

            <div className="mt-6 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
                {rows.map((r) => (
                    <div key={r.id} data-testid={`store-review-${r.id}`}
                        className="flex flex-col rounded-3xl border border-white/10 bg-white/[0.03] p-5">
                        <RatingStars n={r.rating} color={theme?.primary || "#f5b544"} />
                        {r.title && <p className="mt-2 font-display text-base font-bold leading-tight">{r.title}</p>}
                        <p className="mt-2 text-sm leading-relaxed text-zinc-300">{r.body}</p>
                        <p className="mt-3 font-mono text-[11px] uppercase tracking-[0.18em] text-zinc-500">
                            {r.author} · {day(r.created_at)}
                            {r.verified && <span style={{ color: theme?.primary }}> · verified order</span>}
                        </p>
                        {r.reply && (
                            <p className="mt-3 rounded-2xl px-3 py-2 text-[13px] leading-relaxed text-zinc-300"
                                style={{ background: tint(theme?.primary || "#2563EB", 0.08) }}>
                                <span className="font-semibold text-white">{name} replied: </span>{r.reply.body}
                            </p>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
}
